import React, { Component } from 'react';

import { localeStrings as strings } from 'applicationConfig';

import BaseOrderView from './BaseOrderView';

const headers = strings.dataViewing.individualTradeViewRows;

const GRID_COLUMNS = [
  {
    field: 'tradeDate',
    columnHeader: headers.tradeDate,
    width: '11em'
  },
  {
    field: 'price',
    columnHeader: headers.price,
    width: '7em'
  },
  {
    field: 'missingPrice',
    columnHeader: headers.missingPrice,
    width: '8em'
  },
  {
    field: 'currency',
    columnHeader: strings.dataViewing.tableHeaders.currency,
    width: '5.5em'
  },
  {
    field: 'vol',
    columnHeader: headers.vol,
    width: '7em'
  },
  {
    field: 'priceNot',
    columnHeader: headers.priceNot,
    width: '5em'
  },
  {
    field: 'publicationDate',
    columnHeader: headers.publicationDate,
    width: '12em'
  },
  {
    field: 'transactionID',
    columnHeader: headers.transactionID,
    width: '8em'
  },
  {
    field: 'notionalAmt',
    columnHeader: headers.notionalAmt,
    width: '12em'
  },

  {
    field: 'notionalCcy',
    columnHeader: headers.notionalCcy,
    width: '4em'
  },

  {
    field: 'flags',
    columnHeader: headers.flags,
    width: '12em'
  },
  {
    field: 'qtyMeasUnit',
    columnHeader: headers.qtyMeasUnit,
    width: '5em'
  },

  {
    field: 'type',
    columnHeader: headers.type,
    width: '5em'
  },
  {
    field: 'cleared',
    columnHeader: headers.cleared,
    width: '5em'
  },
  {
    field: 'thirdCountryExecutionVenue',
    columnHeader: headers.thirdCountryExecutionVenue,
    width: '12em'
  }
];

const GRID_COLUMNS_UK_EQUITY = [
    {
      field: 'tradeDate',
      columnHeader: headers.tradeDate,
      width: '11em'
    },
    {
      field: 'price',
      columnHeader: headers.price,
      width: '7em'
    },
    {
      field: 'priceCondition',
      columnHeader: headers.priceCondition,
      width: '8em'
    },
    {
      field: 'priceMajorCurrency',
      columnHeader: strings.dataViewing.tableHeaders.priceMajorCurrency,
      width: '8em'
    },
    {
      field: 'vol',
      columnHeader: headers.vol,
      width: '7em'
    },
    {
      field: 'priceNot',
      columnHeader: headers.priceNot,
      width: '5em'
    },
    {
      field: 'publicationDate',
      columnHeader: headers.publicationDate,
      width: '12em'
    },
    {
      field: 'transactionID',
      columnHeader: headers.transactionID,
      width: '8em'
    },
    {
      field: 'notionalAmt',
      columnHeader: headers.notionalAmt,
      width: '12em'
    },
  
    {
      field: 'notionalCcy',
      columnHeader: headers.notionalCcy,
      width: '4em'
    },
  
    {
      field: 'flags',
      columnHeader: headers.flags,
      width: '12em'
    },
    {
      field: 'qtyMeasUnit',
      columnHeader: headers.qtyMeasUnit,
      width: '5em'
    },
  
    {
      field: 'type',
      columnHeader: headers.type,
      width: '5em'
    },
    {
      field: 'cleared',
      columnHeader: headers.cleared,
      width: '5em'
    }
  ];

class TradeDisplayView extends Component {
  render() {
    const isUkVenueAndEquityAssetClass =
      this.props.order.venueLocation === "UK" && this.props.order.assetClass === "Equity & Equity-like";

    const columns = isUkVenueAndEquityAssetClass ? GRID_COLUMNS_UK_EQUITY : GRID_COLUMNS;

    return (
      <BaseOrderView
        id="tradeDisplayView"
        tradeDisplay={true}
        showExpandCollapse={true}
        gridColumns={columns}
        {...this.props}
      />
    );
  }
}

export default TradeDisplayView;



// WEBPACK FOOTER //
// ./src/containers/DataViewing/orderViews/TradeDisplayView.jsx